<template>
    <div>
        <div
            v-for="(penyedia, index) in penyediaList"
            :key="penyedia.id || index"
            class="penyedia-entry mb-3"
        >
            <Dropdown
                v-model="penyediaList[index].id"
                :options="filteredPenyediaOptions(penyedia.id)"
                optionLabel="nama_perusahaan"
                optionValue="id"
                filter
                filterBy="nama_perusahaan"
                @filter="fetchPenyedia"
                @change="validateUniqueness(index)"
                placeholder="Select Penyedia"
            />
            <button 
                @click="removePenyedia(index)"
                class="px-4 py-2 bg-red-500 text-white rounded ml-2"
            >
                Delete
            </button>
        </div>
        <button :disabled="!tender"
            @click="addPenyedia"
            class="px-4 py-2 bg-green-500 text-white rounded mt-3"
        >
            Add Penyedia
        </button>
    </div>
</template>

<script>
import { defineComponent, onBeforeUnmount } from "vue";
import Dropdown from "primevue/dropdown";
import axios from "axios";

export default defineComponent({
    components: {
        Dropdown,
    },
    props: {
        list_penyedia: Array,
        jenis_pekerjaan_id : Number,
        tender: Boolean,
    },
    data() {
        return {
            penyediaOptions: [],
            penyediaList: this.list_penyedia ? [...this.list_penyedia] : [],
            // Cancel token for axios requests
            cancelTokenSource: null,
        };
    },
    watch: {
        list_penyedia: {
            handler(newValue) {
                // Avoid infinite loop by checking if values actually changed
                const currentValue = JSON.stringify(this.penyediaList);
                const newValueString = JSON.stringify(newValue ? [...newValue] : []);
                if (currentValue !== newValueString) {
                    this.penyediaList = newValue ? [...newValue] : [];
                }
            },
            deep: true,
        },
        penyediaList: {
            handler(newValue) {
                // Emit the updated penyediaList to the parent component
                this.$emit("update:list_penyedia", newValue);
            },
            deep: true,
        },
    },
    mounted() {
        // Create cancel token source
        this.cancelTokenSource = axios.CancelToken.source();
        this.fetchPenyedia({ value: "" });
    },
    beforeUnmount() {
        // Cancel any pending requests
        if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel('Component unmounted');
        }
    },
    methods: {
        addPenyedia() {
            this.penyediaList.push({ id: null });
        },
        removePenyedia(index) {
            this.penyediaList.splice(index, 1);
        },
        async fetchPenyedia(event) {
            console.log("Keyword : ", event.value);
            console.log("Jenis Pekerjaan ID : ", this.jenis_pekerjaan_id);
            
            // Cancel previous request if exists
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('New request initiated');
            }
            
            // Create new cancel token
            this.cancelTokenSource = axios.CancelToken.source();
            
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_penyedia",
                    {
                        params: {
                            keyword: event.value || "",
                            jenis_pekerjaan_id: this.jenis_pekerjaan_id,
                        },
                    },
                    {
                        cancelToken: this.cancelTokenSource.token
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.penyediaOptions = response.data;
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error("Error fetching penyedia:", error);
                }
            }
        },
        filteredPenyediaOptions(currentId) {
            // Ensure the currently selected option is available in the dropdown options
            return this.penyediaOptions.concat(
                this.penyediaList.filter(
                    (p) =>
                        p.id === currentId &&
                        !this.penyediaOptions.some(
                            (option) => option.id === currentId
                        )
                )
            );
        },
        validateUniqueness(currentIndex) {
            const currentId = this.penyediaList[currentIndex]?.id;
            if (
                currentId &&
                this.penyediaList.filter(
                    (penyedia) => penyedia.id === currentId
                ).length > 1
            ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Penyedia duplikat terdeteksi. Pastikan setiap penyedia unik.",
                    life: 3000,
                });
                this.penyediaList[currentIndex].id = null;
            }
        },
    },
});
</script>
